import { useTranslation } from "react-i18next";
import TabTransfer from "../../PointQuery/tabTransfer";
import GetParams from "../../../utils/getParams";
import { Divider } from "semantic-ui-react";
import { COMMON_WEB_PATH } from "../../../constant";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";
import LazyImage from "../../../components/Loading/lazyImage";
import useTransferMode from "../../../hook/useTransferMode";
import NowGame from "./nowGame";

const TransferDetail = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`gamebox.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const gameConfig = useSelector((state) => state.isGameConfig);

  const isTransferMode = useTransferMode();

  return (
    <div>
      <NowGame />
      <Divider className="!my-[5px]" />
      {isTransferMode && <TabTransfer />}
    </div>
  );
};

export default TransferDetail;
